import React, { useEffect, useState } from "react";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import {
  setClientBranchActions,
  SetTheSiteTransferCreateActions,
  SetTheSiteTransferRetrieveActions,
  SetTheSiteTransferEditsActions,
} from "../../../Redux/Slice";
import useDebouncedEffect from 'use-debounced-effect';

const SiteCreateEdit = (props) => {
  const { show, setShow, currentPage, EditId, selectVal, datas, Datestate ,Emp_old ,
    client_id_sfrom ,
    searchemp ,
    page_size_approved,
    Count_of_block ,
    black_list,
    ALL_BRANCHES
   } =
    props;
  let [nameList, setOptions] = useState([]);
  const [multiselect, setMuliselect] = useState([]);
  const [stateerror, setStateError] = useState("");
  const [States, setState] = useState([]);
  const state = useSelector((state) => state);
  const form_data = new FormData();
  const today = new Date().toISOString().split("T")[0]; // Get today's date in YYYY-MM-DD format

  const initialState = {
    request_type: "request",
    reason: "",
    user_id: "",
    form_client: "",
    to_client: "",
    joining_date: null,
    end_date: null,
    is_permanentTransfer:true,
  };
  const approvefrom = new FormData();
  const [data, setdatas] = useState(initialState);

  useEffect(() => {
    if (EditId != "") {
      dispatch(SetTheSiteTransferRetrieveActions({ EditId }));
    }
  }, []);

  let currentDate = new Date();
  let year = currentDate.getFullYear();

  // Calculate the end of the current year
  let endOfYear = new Date(year, 11, 31); // December is 11th month (zero-based index)

  // Format the current date and end of year
  let currentMonth =
    (currentDate.getMonth() + 1 < 10 ? "0" : "") + (currentDate.getMonth() + 1);
  let currentDay =
    (currentDate.getDate() < 10 ? "0" : "") + currentDate.getDate();
  let formattedDate = `${year}-${currentMonth}-${currentDay}`;

  let endOfYearMonth =
    (endOfYear.getMonth() + 1 < 10 ? "0" : "") + (endOfYear.getMonth() + 1);
  let endOfYearDay =
    (endOfYear.getDate() < 10 ? "0" : "") + endOfYear.getDate();
  let formattedEndOfYear = `${year}-12-31`;

  console.log(`Current Date: ${formattedDate}`);
  console.log(`End of Year: ${formattedEndOfYear}`);

  const [support_doc, setsupportdoc] = useState();
  const [reasonerr, setReasonerr] = useState("");
  const [nameList4, setOptions4] = useState([]);
  const [clientids, setselectIdc] = useState();
  const dispatch = useDispatch();
  const [clientErr, setClientErr] = useState();
  const [clientSelectval, setclientSel] = useState();
  const initialStateSearch = {
    client: "",
  };
  const [SearchedVal, setSearched] = useState(initialStateSearch); 
   const initialDebouanceSearch = {
    client: "",
};

const [SearchDebounance, setSearchDebounance] = useState(initialDebouanceSearch);


  const [startde, setStartD] = useState("");
  const [EndDate, setEndDate] = useState("");
  //   console.log(
  //     state.ClientBranchIDs,
  //     "ClientBranchIDs",
  //     state.ClientBranchIDs.UserObject
  //   );
  const HandleChanges = (e) => {
  // setdatas((prev) => ({
  //   ...prev,
  //   [e.target.name]: e.target.value,
  // }));
  console.log(e.target.value ,"e.target.value", e.target.name);
  
  setdatas({
    ...data,
     [e.target.name]: e.target.value,
  })
    console.log(e.target.value ,"e.target.value", e.target.name , data);

};
  const HandleClientBranches = (selectedVal) => {
    console.log(selectedVal.value, "va;lusfodcn ");
    setclientSel(selectedVal);
    setdatas({
      ...data,
      to_client: selectedVal.value,
    });
    setselectIdc(selectedVal.value);
  };

  useEffect(() => {
const data = state?.SiteTransferRetrieveCall?.SiteTramsferDataretrieve;
const isValidData =
  EditId !== undefined &&
  EditId !== "" &&
  data !== undefined &&
  (!Array.isArray(data) || data.length > 0) &&
  data?.to_client !== undefined &&
  data?.to_client !== null &&
  data?.to_client?.client_id?.id !== undefined;
    if (isValidData) {
      setdatas({
        ...data,

        to_client: clientids,
        joining_date:
          state.SiteTransferRetrieveCall.SiteTramsferDataretrieve.joining_date,
        end_date:
          state.SiteTransferRetrieveCall.SiteTramsferDataretrieve.end_date,
        reason: state.SiteTransferRetrieveCall.SiteTramsferDataretrieve.reason,
        is_permanentTransfer:state.SiteTransferRetrieveCall.SiteTramsferDataretrieve.is_permanentTransfer
      });
    }
  }, [state.SiteTransferRetrieveCall.SiteTramsferDataretrieve, clientids]);
  useDebouncedEffect(
    () => {
        if (setSearchDebounance) {
            setSearched({
                ...SearchedVal,
                client: SearchDebounance.client,
            });

        }
    },
    500,
    [SearchDebounance]
);


  const handleInputChangeClinet = (Val) => {
    setSearchDebounance({
      ...SearchDebounance,
      client:Val
    })
  };

  ///---Branch-----------------

  useEffect(() => {
    // const payload = {
    //   search: SearchedVal.client,
    //   page_size: 10,
    //   page: 1,
    //   client: "",
    //   is_reliever: ALL_BRANCHES == true ? "true" :"false"
    // };
    const payload = {
    search: SearchedVal.client,
    page_size: 20,
    page: 1,
    client: "",
    // is_reliever: "false"
    };


    dispatch(setClientBranchActions(payload));
  }, [ show,SearchedVal.client]);

useEffect(() => {
  const branches = state.ClientBranch.ClientBranchess;
  const excludeId = state.ClientBranchIDs?.BranchObject?.value; // id to skip

  if (branches && branches?.length > 0) {
    const objectArray = branches
      .filter((element) => element.id !== excludeId) // ❌ exclude this ID
      .map((element) => ({
        value: element.id,
        label: element.branch_code
          ? `${element.branch_code}-${element.client_name.toUpperCase()}`
          : element.client_name.toUpperCase(),
      }));

    setOptions4(objectArray);
  }
  else{
        setOptions4([]);
  }
  }, [state.ClientBranch.ClientBranchess, SearchedVal.client, state.ClientBranchIDs.BranchObject]);





  useEffect(() => {
    if (
      
      EditId != undefined &&
      EditId != "" &&
      state.SiteTransferRetrieveCall.SiteTramsferDataretrieve != undefined &&
      state.SiteTransferRetrieveCall.SiteTramsferDataretrieve.to_client !=
        undefined &&
      state.SiteTransferRetrieveCall.SiteTramsferDataretrieve.to_client !=
        null &&
      state.SiteTransferRetrieveCall.SiteTramsferDataretrieve.to_client
        .client_id != undefined &&
      state.SiteTransferRetrieveCall.SiteTramsferDataretrieve.to_client
        .client_id != null &&
      state.SiteTransferRetrieveCall.SiteTramsferDataretrieve.to_client
        .client_id != "" &&
      state.SiteTransferRetrieveCall.SiteTramsferDataretrieve.to_client
        .client_id.client_name != undefined &&
      state.SiteTransferRetrieveCall.SiteTramsferDataretrieve.to_client
        .client_id.client_name != null
    ) {
      console.log(
        state.SiteTransferRetrieveCall.SiteTramsferDataretrieve.to_client
          .client_id.client_name,
        "SiteTramsferDataretrieve "
      );

      //  console.log({value:
      //     state.SiteTransferRetrieveCall.SiteTramsferDataretrieve.to_client
      //       .client_id.id,
      //   label:
      //     state.SiteTransferRetrieveCall.SiteTramsferDataretrieve.to_client
      //       .client_id.client_name},  "saisdasid basi");
      setclientSel({
        value:
          state.SiteTransferRetrieveCall.SiteTramsferDataretrieve.to_client
            .client_id.id,
        label:
          state.SiteTransferRetrieveCall.SiteTramsferDataretrieve.to_client
            .client_id.client_name,
      });

      setselectIdc(
        state.SiteTransferRetrieveCall.SiteTramsferDataretrieve.to_client
          .client_id.id
      );
    }
  }, [state.SiteTransferRetrieveCall.SiteTramsferDataretrieve]);

  console.log(data, "BranchObject");
  const HandleSubmit = () => {
    var a = 0;
    if (EditId == undefined || EditId == "") {
      form_data.append(
        "data",
        JSON.stringify({
          request_type: data.request_type,
          reason: data.reason,
          user_id: state.ClientBranchIDs.UserObject.value,
          from_client: state.ClientBranchIDs.BranchObject.value,
          to_client: data.to_client,
          joining_date: data.joining_date,
          end_date: data.end_date,
        })
      );

      approvefrom.append(
        "data",
        JSON.stringify({
          status: "approve",
        })
      );

      if (!data.to_client || data.to_client == undefined) {
        setClientErr("*Client branch is required");
        a = 1;
      }
      if (data.reason == "") {
        setReasonerr("*Reason is required");
        a = 1;
      }
      if(data?.is_permanentTransfer == false){
      if (!data.joining_date ||  data.joining_date == undefined) {
        setStartD("*Joining date is required");
        a = 1;
      }
      if (!data.end_date || data.end_date == undefined) {
        setEndDate("*End date is required");
        a = 1;
      }
    }

      if (a == 0) {
        const payload = {
          form_data: {
            request_type: data.request_type,
            reason: data.reason,
            user_id: state.ClientBranchIDs.UserObject.value,
            from_client: state.ClientBranchIDs.BranchObject.value,
            to_client: data.to_client,
            joining_date: data?.is_permanentTransfer == true ? null : data.joining_date,
            end_date: data?.is_permanentTransfer == true ? null : data.end_date,
            is_permanentTransfer:data?.is_permanentTransfer
          },

          data: datas,
          selectVal: selectVal,
          from_client: state.ClientBranchIDs.SingelEmployeelistes,
          user: state.ClientBranchIDs.EmployeeDetailsProfile,
          to_client: data.to_client,
          userid: state.ClientBranchIDs.UserObject.value,
          count: 2,
          /// for call the , approved emp 
          Emp_old:Emp_old,
          page_size_approved:page_size_approved,
          searchemp:searchemp,
          client_id_sfrom:client_id_sfrom,
          Count_of_block:Count_of_block ? Count_of_block : "2",
black_list:black_list,
currentPage:currentPage,

          // month: Datestate.month,
          // year: Datestate.year,
          // date:Datestate.date ,
          // month: Datestate.month,
          // year: Datestate.year,
          // date:Datestate.date ,
        };

        dispatch(SetTheSiteTransferCreateActions(payload, setShow(false)));
        setdatas(initialState)
      }
    }
  };
  console.log(data, "skiowuiquwe");

  const HandleEdits = () => {
    if (EditId != undefined && EditId != "") {
      var a = 0;

      form_data.append(
        "data",
        JSON.stringify({
          request_type: data.request_type,
          reason: data.reason,
          user_id: state.ClientBranchIDs.UserObject.value,
          form_client: state.ClientBranchIDs.BranchObject.value,
          to_client: data.to_client,
          joining_date: data.joining_date,
          end_date: data.end_date,
        })
      );
      if (!data.to_client || data.to_client == undefined) {
        setClientErr("*Client Branch is required");
        a = 1;
      }
      if (data.reason == "") {
        setReasonerr("*Reason is required");
        a = 1;
      }

      if(data?.is_permanentTransfer == false){
      if (!data.joining_date  || data.joining_date == undefined) {
        setStartD("*Joining Date is required");
        a = 1;
      }
      if ( !data.end_date || data.end_date == undefined) {
        setEndDate("*End Date is required");
        a = 1;
      }
    }
      if (a == 0) {
        const payload = {
          form_data: {
            request_type: data.request_type,
            reason: data.reason,
            user_id: state.ClientBranchIDs.UserObject.value,
            form_client: state.ClientBranchIDs.BranchObject.value,
            to_client: data.to_client,
            joining_date: data?.is_permanentTransfer == true ? null : data.joining_date,
            end_date:  data?.is_permanentTransfer == true ? null : data.end_date,
            is_permanentTransfer:data?.is_permanentTransfer
          },
          data: datas,
          selectVal: selectVal,
          from_client: state.ClientBranchIDs.SingelEmployeelistes,
          user: state.ClientBranchIDs.EmployeeDetailsProfile,
          EditId: EditId,
          count: 2,

        };

        dispatch(SetTheSiteTransferEditsActions(payload, props.setShow(false)));
        setdatas(initialState)

      }
    }
  };

  const preventTyping = (e) => {
    e.preventDefault();
  };
  function onFocus(event) {
    event.target.showPicker();
  }

  return (
    <>
      <div className="RoleCreatePopup">
        <div className="BeforePopUp">
          <div className="RolePopups" style={{ width: "50%" }}>
            <div className="asds">
              <div class="ModalHeader"
              style={{color:"#fff", background:"#234492"}} 
              >
                  <span className="UserCreate" style={{color:"#fff"}}>Site Transfer </span>


                <div className="CloseIcon" onClick={(e) => setShow(false)}>
                  <CloseOutlinedIcon />
                </div>
              </div>

              <from
                class="row g-3 form-fields-wrapper"
                style={{ padding: "20px" }}
              >
                <div className="col-6 field-div" id="RegionCreatePOPUP">
                  <label for="validationCustom01" class="form-label">
                    User<span style={{ color: "red" }}>*</span>
                  </label>

                  <Select
                    className="Selects"
                    styles={{
                      position: "relative",
                      top: "60px",
                      padding: "70vh",
                    }}
                    isDisabled
                    value={state.ClientBranchIDs.UserObject}
                  />
                </div>


                <div className="col-6 mt-2 field-div" id="RegionCreatePOPUP">
                  <label for="validationCustom01" class="form-label">
                    From Client Name<span style={{ color: "red" }}>*</span>
                  </label>

                  <Select
                    className="Selects"
                    styles={{
                      position: "relative",
                      top: "60px",
                      padding: "70vh",
                    }}
                    isDisabled
                    value={state.ClientBranchIDs.BranchObject}
                  />
                </div>


                     <div class="col-6 6 mt-4 field-div">
                  <label
                    for="validationCustom01"
                    class="form-label"
                    style={{ fontSize: "15px" }}
                  >
                    To Client Name <span style={{ color: "red" }}>*</span>
                  </label>

                  <Select
                    className="Selects"
                    styles={{
                      position: "relative",
                      top: "60px",
                      // padding: "70vh",
                      padding:"0px !important"
                    }}
                    filterOption={() => true}
                    onChange={(e) => {
                      HandleClientBranches(e);
                      setClientErr("");
                    }}
                    options={nameList4}
                    onInputChange={handleInputChangeClinet}
                    placeholder="Search"
                    value={clientSelectval}
                  />

                  <p style={{ color: "red", marginTop: "5px" }}>{clientErr}</p>
                </div>

<div className="col-6 field-div d-flex align-items-center" style={{ gap: "10px" }}>
  <label
    htmlFor="is_permanentTransfer"
    className="form-label mb-0"
    style={{ fontSize: "15px", cursor: "pointer", marginLeft:"34px" }}
  >
    Permanent Transfer
  </label>
  <input
    type="checkbox"
    id="is_permanentTransfer"
    className="form-check-input"
    checked={data.is_permanentTransfer || false}
    onChange={(e) =>
      HandleChanges({
        target: {
          name: "is_permanentTransfer",
          value: e.target.checked,
        },
      })
    }
    name="is_permanentTransfer"
    style={{
      transform: "scale(1.3)",
      cursor: "pointer",
      marginLeft:"3px",
      marginTop:"-2px"
    }}
  />
</div>



{ data?.is_permanentTransfer  == true ? "" :
              

              <>
                <div class="col-6 field-div">
                  <label
                    for="validationCustom01"
                    class="form-label"
                    style={{ fontSize: "15px" }}
                  >
                    Joining Date <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="date"
                    class="form-control"
                    value={data.joining_date}
                    autoComplete="off"
                    onChange={(e) => {
                      HandleChanges(e);
                      setStartD("");
                    }}
                    required
                    // max={formattedEndOfYear}
                    // min={formattedDate}
                    name="joining_date"
               
                    onKeyDown={preventTyping}
                    onClick={onFocus}
                    // onFocus={(e) => e.target.showPicker()}
  min={new Date().toISOString().split("T")[0]} // ✅ allows only future dates

                  ></input>
                  <p style={{ color: "red", marginTop: "5px" }}>{startde}</p>
                </div>

                <div class="col-6 field-div">
                  <label
                    for="validationCustom01"
                    class="form-label"
                    style={{ fontSize: "15px" }}
                  >
                    End Date <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="date"
                    class="form-control"
                    value={data.end_date}
                    autoComplete="off"
                    onChange={(e) => {
                      HandleChanges(e);
                      setEndDate("");
                    }}
                    // max={formattedEndOfYear}
                    // min={formattedDate}
                    onKeyDown={preventTyping}
                    onClick={onFocus}
                    // onFocus={(e) => e.target.showPicker()}
  min={new Date().toISOString().split("T")[0]} // ✅ allows only future dates

                    required
                    name="end_date"
                 
                  ></input>
                  <p style={{ color: "red", marginTop: "5px" }}>{EndDate}</p>
                </div>
              
              </>

                  }

         <div class="col-6 field-div">
                  <label
                    for="validationCustom01"
                    class="form-label"
                    style={{ fontSize: "15px" }}
                  >
                    Reason <span style={{ color: "red" }}>*</span>
                  </label>
                  <textarea
                    type="text"
                    class="form-control"
                    value={data.reason}
                    autoComplete="off"
                    onChange={(e) => {
                      HandleChanges(e);
                      setReasonerr("");
                    }}
                    required
                    name="reason"
                    style={{
                      padding: "15px",
                    }}
                  ></textarea>
                  <p style={{ color: "red", marginTop: "5px" }}>{reasonerr}</p>
                </div>

  

                <div
                  className="RoleButton"
                  style={{
                    display: "flex",
                    gap: "15px",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginTop:"50px"
                  }}
                >
                  <button
                    class="btn  SaveBtn"
                    type="submit"
                    onClick={(e) => {
                      HandleSubmit(e);

                      HandleEdits(e);
                    }}
                  >
                    Submit
                  </button>

                  <button class="btn CancelBtn" onClick={(e) => setShow(false)}>
                    Cancel
                  </button>
                </div>
              </from>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SiteCreateEdit;
